// extracted by mini-css-extract-plugin
export default {"container":"identifierField_container__t9k7H"};